<template>
  <div style="margin-top: 10px">
    <div class="base-margin__bottom-10 base-flex">
      <div class="box-card">
        <div v-for="n in myLineChartList.length" :id="siteMyLineChart(`echartsBox${echartsId}`, n)"
             :key="n"
             v-loading="myLineChartList[n - 1 ].loading"
             class="echartsBoxCls"
        >
          <div :id="siteMyLineChart(echartsId, n)"></div>
          <div :style="`position: absolute; top: 8px; left: ${myLineChartList[n - 1].leftDistance}px;`">
            <el-tooltip :content="myLineChartList[n - 1].value || ''" class="item" effect="dark" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import * as echarts from 'echarts';
import { postRequest } from '@/common/libs/request';
import dayjs from 'dayjs';
import { echartsOptions } from './constants/index';

export default {
  name: 'echarts',
  props: {
    pickerValue: {  // 时间
      type: Array,
      default: () => [],
    },
    selectOptionsValue: {  // 时间间隔
      type: Number,
      default: 10,
    },
    dayJsFormat: {  // 时间格式化
      type: String,
      default: 'HH:mm',
    },
    echartsId: {
      type: String,
      default: '',
    },
    myLineCharDataList: {
      type: Array,
      default: () => [],
    },
    xAxisData: {
      type: Array,
      default: () => [],
    },
    instanceInfo: {
      type: Object,
      default: null,
    },
    monitorType: {
      type: String,
      default: '',
    },
    multiCloudPartitionInstanceId: Number,
  },
  data() {
    return {
      activeNames: ['1'],
      myLineChartList: this.myLineCharDataList,
      cpuMonitoring: [],
      networkMonitoring: [],
      memoryMonitoring: [],
      diskMonitoring: [],
      url: '',
    };
  },
  created() {
    if (this.instanceInfo.type === 'volcengine') {
      this.url = '/api/eda/common/volcengine/getInstanceMetricData';
    }
    if (this.instanceInfo.type === 'huaweicloud') {
      this.url = '/api/eda/common/huaweicloud/getInstanceMetricData';
    }

    if (this.instanceInfo.type === 'aliyun') {
      this.url = '/api/eda/common/aliyun/getInstanceMetricData';
    }

    if (this.monitorType === 'all') {
      this.url = '/api/eda/common/multicloud/getMultiCloudPartitionMetricData';
    }
  },

  mounted() {
    this.init('');
  },

  methods: {
    /**
     * 页面初始化 窗口改变
     */
    init(type) {
      for (let i = 1; i < this.myLineChartList.length + 1; i++) {
        const echartsBox = document.getElementById(`echartsBox${this.echartsId}${i}`);
        const echartsContent = document.getElementById(`${this.echartsId}${i}`);
        if (echartsBox && echartsContent) {
          echartsContent.style.width = `${echartsBox.offsetWidth}px`;
          echartsContent.style.height = `${echartsBox.offsetHeight}px`;
          if (type === 'resize') {
            this.myLineChartList[i - 1].dom.resize();
          } else {
            this.myLineChartList[i - 1].dom = echarts.init(echartsContent);
          }
        }
      }
    },

    /**
     * 获取数据
     * @param {Array} pickerValue 时间
     * @param {Number} selectOptionsValue 时间间隔
     * @param {Number} subclusterId 子集群id
     */
    async getEchartsData(pickerValue, selectOptionsValue, subclusterId, batchlndex, type) {
      for (let i = 1; i < this.myLineChartList.length + 1; i++) {
        this.filterList(pickerValue, selectOptionsValue, subclusterId, batchlndex, type, i);
      }
    },


    filterList(pickerValue, selectOptionsValue, subclusterId, batchlndex, type, i) {
      this[type][i] = Object.assign({}, echartsOptions);
      this.myLineChartList[i - 1].loading = true;
      this[type][i].xAxis.data = [];
      this[type][i].series.data = [];

      if (this.monitorType !== 'all') {
        this[type][i].grid.left = '10%';
      }

      postRequest(this.url, {
        startTime: pickerValue[0] || '',
        endTime: pickerValue[1] || '',
        period: selectOptionsValue,
        metricName: this.myLineChartList[i - 1].key,
        multiCloudPartitionInstanceId: this.multiCloudPartitionInstanceId,
        multiCloudPartitionId: Number(this.instanceInfo.id),
        // batchlndex: batchlndex ? [batchlndex.toString()] : [],
      }).then((res) => {
        const resList = [];
        if (this.instanceInfo.type === 'volcengine') {
          if (this.monitorType === 'all') {
            if (res?.list.length !== 0) {
              res?.list.map((item) => {
                resList.push([item.Name * 1000, item.Value]);
              });
            } else {
              this.dataErrorHandle(i);
              this.commonRevise(i);
            }
          } else {
            if (res?.MetricDataResults[0].DataPoints.length !== 0) {
              res?.MetricDataResults[0].DataPoints.map((item) => {
                resList.push([item.Timestamp * 1000, (item.Value / this.myLineChartList[i - 1].conversion).toFixed(2)]);
              });
            } else {
              this.dataErrorHandle(i);
              this.commonRevise(i);
            }
          }
        }
        if (this.instanceInfo.type === 'huaweicloud') {
          if (this.monitorType === 'all') {
            if (res?.list.length !== 0) {
              res?.list.map((item) => {
                resList.push([item.Name, item.Value]);
              });
            } else {
              this.dataErrorHandle(i);
              this.commonRevise(i);
            }
          } else {
            if (res?.datapointList.length !== 0) {
              res?.datapointList.map((item) => {
                resList.push([item.timestamp, (item.average / this.myLineChartList[i - 1].conversion).toFixed(2)]);
              });
            } else {
              this.dataErrorHandle(i);
              this.commonRevise(i);
            }
          }
        }


        if (this.instanceInfo.type === 'aliyun') {
          if (this.monitorType === 'all') {
            if (res?.list.length !== 0) {
              res?.list.map((item) => {
                resList.push([item.Name, item.Value]);
              });
            } else {
              this.dataErrorHandle(i);
              this.commonRevise(i);
            }
          } else {
            if (res?.dataPoints.length !== 0) {
              res?.dataPoints.map((item) => {
                resList.push([item.timestamp, (item.average / this.myLineChartList[i - 1].conversion).toFixed(2)]);
              });
            } else {
              this.dataErrorHandle(i);
              this.commonRevise(i);
            }
          }
        }

        this[type][i].yAxis.min = null;
        this[type][i].yAxis.max = null;
        this[type][i].xAxis.data = resList.map(item => item[0]);
        this[type][i].xAxis.axisLabel.formatter = value => dayjs(Number(value)).format(this.dayJsFormat);
        this[type][i].series.data = resList.map(item => Number(item[1]));

        this.commonRevise(i, type);
      })
        .catch(() => {
          this.dataErrorHandle(i, type);
          this.commonRevise(i, type);
        });
      // await this.commonRevise(i);
    },

    /**
     * 数据为空 或者报错时
     */
    dataErrorHandle(i, type) {
      this[type][i].series.data = [];
      this[type][i].xAxis.data = this.xAxisData.map(value => value * 1000);
      this[type][i].xAxis.axisLabel.formatter = value => dayjs(Number(value)).format(this.dayJsFormat);
      this[type][i].yAxis.min = 0;
      this[type][i].yAxis.max = 100;
      // this[type][i].graphic[1].children[0].style.text = '暂无数据';
    },

    /**
     * 公共修改
     */
    commonRevise(i, type) {
      this[type][i].title.text = this.myLineChartList[i - 1]?.name;
      this[type][i].series.name = this.myLineChartList[i - 1]?.name;
      this.myLineChartList[i - 1].loading = false;
      this[type][i] && this.myLineChartList[i - 1].dom.setOption(this[type][i], true);
    },

    /**
     * 处理echarts
     * @param i id
     */
    siteMyLineChart(value, i) {
      return `${value}${i}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.echartsBoxCls {
  width: 48%;
  height: 350px;
  padding: 3px;
  position: relative;
  margin-bottom: 12px;
  margin-left: 2px;
  margin-right: 8px;
  box-shadow: 0 2px 4px 0 rgba(54, 58, 80, .32);
  border: 1px solid #eee;
  background: #FFFFFF;
  border-radius: 2px;
}

.box-card {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-height: none;
  margin-left: 6px;
  margin-bottom: 30px;
}

::v-deep .el-card__body {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden
}
</style>
